import React from 'react';
import Translate from 'react-translate-component';

import { checkGroup } from 'helpers/documentsHelpers';
import FieldsGroup from 'components/cards/document/fields/FieldsGroup';

export const cardEdited = checkGroup (({ documentUpdateDate, documentUpdatePerson, documentLettersUpdate }) => (
    <FieldsGroup translate="cardEdited">
        <b>{documentUpdateDate} {documentUpdatePerson} </b>
        <span><Translate component="span" content="xml.PplInterv.DocumentLettersUpdate" /></span>
        <b>{documentLettersUpdate}</b>
    </FieldsGroup>
));
